import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map } from 'rxjs';
import { ProfileService } from '../../services/profile.service';

export type ApplyChoiceKind = 'job' | 'initiative';

export interface ApplyChoiceLinks {
  /** Where a member applies; login and signup come back here. */
  member: string;
  guest: string[];
  back: string[];
}

export function applyChoiceLinks(
  kind: ApplyChoiceKind,
  id: string
): ApplyChoiceLinks {
  return kind === 'job'
    ? {
        member: `/jobs/${id}/apply`,
        guest: ['/jobs', id, 'apply', 'public'],
        back: ['/jobs', id],
      }
    : {
        member: `/schools/${id}/initiative`,
        guest: ['/schools', id, 'initiative'],
        back: ['/schools', id],
      };
}

export const kindOf = (route: ActivatedRouteSnapshot): ApplyChoiceKind =>
  route.data['kind'] === 'initiative' ? 'initiative' : 'job';

/** Signed in already: no choice to make, straight to the member form. */
export const applyChoiceGuard = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const links = applyChoiceLinks(kindOf(route), route.paramMap.get('id') ?? '');
  return inject(ProfileService)
    .isAuthorized()
    .pipe(
      map(authorized => (authorized ? router.parseUrl(links.member) : true))
    );
};
